import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
import { WebhookEventList } from '../../components/webhook-logs/WebhookEventList';
import { WebhookFilters } from '../../components/webhook-logs/WebhookFilters';
import { WebhookEventDetails } from '../../components/webhook-logs/WebhookEventDetails';
import { WebhookEventsQuery } from '../../types';
import { Button } from '../../components/ui/button';

export function WebhookLogsPage() {
  const [selectedEventId, setSelectedEventId] = useState<string | undefined>();
  const [showDetails, setShowDetails] = useState(false);
  const [filters, setFilters] = useState<WebhookEventsQuery>({});
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();

  const handleEventSelect = (eventId: string) => {
    setSelectedEventId(eventId);
    setShowDetails(true);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await queryClient.invalidateQueries({ queryKey: ['webhook-events'] });
    setIsRefreshing(false);
  };

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)]">
      {/* Header */}
      <div className="border-b px-6 py-4 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Logs de Webhooks</h1>
          <p className="text-sm text-muted-foreground">
            Visualize todos os webhooks recebidos pelo sistema
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleRefresh}
          disabled={isRefreshing}
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
          Atualizar
        </Button>
      </div>

      {/* Main content */}
      <div className="flex-1 overflow-hidden">
        <div className="max-w-6xl mx-auto h-full flex flex-col px-6">
          {/* Filters */}
          <div className="py-4">
            <WebhookFilters onFiltersChange={setFilters} />
          </div>

          {/* Event list with scroll */}
          <div className="flex-1 overflow-y-auto pb-6">
            <WebhookEventList
              filters={filters}
              onEventSelect={handleEventSelect}
              selectedEventId={selectedEventId}
            />
          </div>
        </div>
      </div>

      {/* Event details drawer */}
      <WebhookEventDetails
        eventId={selectedEventId}
        isOpen={showDetails}
        onClose={() => setShowDetails(false)}
      />
    </div>
  );
}
